/* eslint-disable react/jsx-key */
/* eslint-disable max-len */
import React from 'react'
import { ShimmerBadge} from 'react-shimmer-effects'

export default function Skeleton() {
    return (
    
        <>
            <div class="mainDataCntnrTop shadow-s13">
                <div class="flex items-center">
                    <a href="institution_Branches_Onboarded_listingPage.html">
                        <img src="/images/back-btnBlue.svg" alt="icon" loading="lazy"/>
                    </a>
                    <h5 class="pageHeader ml-2.5 adderror">View Branch</h5>
                </div>            
            </div>
            <div class="pb-10 relative">
                {/* <!--Tabs navigation--> */}
                <ul class="mr-4 ml-4 flex list-none flex-row flex-wrap border-b border-[#B3BBC1] pl-9 pt-4 bg-[#fff] sticky top-[64px] left-0 z-[10] -mx-1" role="tablist" data-te-nav-ref=""><li class="institutiondetails1 selected mr-[126px] tab-element" data-te-toggle="pill" data-te-target="#tabs-institutionDetails" role="tab" aria-controls="tabs-institutionDetails" aria-selected="false">Branch Details</li><li class="institutionList1 font-normal tab-element" data-te-toggle="pill" data-te-target="#tabs-institutionuserList" data-te-nav-active="" role="tab" id="branch_user_list" aria-controls="tabs-institutionuserList" aria-selected="false">Branch Users</li></ul>
                {/* <!--Tabs content--> */}
                <div class="mt-2">
                    <div class=" opacity-100 transition-opacity duration-150 ease-linear data-[te-tab-active]:block" id="tabs-institutionDetails" role="tabpanel" aria-labelledby="tabs-institutionDetails-tab">
                        <div class="w-[85%] mx-auto">
                            <div class="flex justify-end">
                                {/* <button class="px-[18px] py-2.5 rounded-lg bg-[#106EB4] text-lg font-medium text-[#FFFFFF] flex justify-center">
                                    Edit
                                </button> */}
                            </div>
                            <div class=" p-4 mt-10">
                                <div class="flex -mx-2">
                                    <div class="w-[60%] px-2">
                                        <div class="w-full">
                                            <div class="pb-4 ">
                                                <div class="flex items-start mt-2">
                                                    <p class="text-f7 font-normal text-[#031624] min-w-[130px]"><ShimmerBadge width={100}/></p>
                                                    <div class="flex items-center">
                                                        <p class="text-f7 font-semibold text-[#031624] break-words"><ShimmerBadge width={200}/></p>
                                                    </div>
                                                </div>
                                                <div class="flex items-start ">
                                                    <p class="text-f7 font-normal text-[#031624] min-w-[130px]"><ShimmerBadge width={100}/></p>
                                                    <div class="flex items-center">
                                                        <p class="text-f7 font-semibold text-[#031624] break-words truncate"><ShimmerBadge width={200}/></p>
                                                    </div>
                                                </div>
                                                <div class="flex items-center ">
                                                    <p class="text-f7 font-normal text-[#031624] min-w-[130px]"><ShimmerBadge width={100}/></p>
                                                    <div class="flex items-center">
                                                        <p class="text-f7 font-semibold text-[#031624] break-words"><ShimmerBadge width={200}/></p>
                                                    </div>
                                                </div>
                                                <div class="flex items-center ">
                                                    <p class="text-f7 font-normal text-[#031624] min-w-[130px]"><ShimmerBadge width={100}/></p>
                                                    <div class="flex items-center">
                                                        <p class="text-f7 font-semibold text-[#031624] break-words"><ShimmerBadge width={200}/></p>
                                                    </div>
                                                </div>
                                                <div class="flex items-center ">
                                                    <p class="text-f7 font-normal text-[#031624] min-w-[130px]"><ShimmerBadge width={100}/></p>
                                                    <div class="flex items-center">
                                                        <p class="text-f7 font-semibold text-[#031624] break-words"><ShimmerBadge width={200}/></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                    <div class="w-[40%] px-2">
                                        <div class="w-full">
                                            <h5 class="text-f7 font-semibold text-[#000000] break-words"><ShimmerBadge width={200}/></h5>
                                            <div class="border-b-2 border-[#95C0E0]">
                                                <div class="flex items-start mt-2">
                                                    <p class="text-f7 font-normal text-[#031624] min-w-[130px]"><ShimmerBadge width={100}/></p>
                                                    <div class="flex items-center">
                                                        <p class="text-f7 font-semibold text-[#031624] break-words"><ShimmerBadge width={200}/></p>
                                                    </div>
                                                </div>
                                                <div class="flex items-start ">
                                                    <p class="text-f7 font-normal text-[#031624] min-w-[130px]"><ShimmerBadge width={100}/></p>
                                                    <div class="flex items-center">
                                                        <p class="text-f7 font-semibold text-[#031624] break-words truncate"><ShimmerBadge width={200}/></p>
                                                    </div>
                                                </div>
                                                <div class="flex items-start ">
                                                    <p class="text-f7 font-normal text-[#031624] min-w-[130px]"><ShimmerBadge width={100}/></p>
                                                    <div class="flex items-center">
                                                        <p class="text-f7 font-semibold text-[#031624] break-words truncate"><ShimmerBadge width={200}/></p>
                                                    </div>
                                                </div>
                                                <div class="flex items-start ">
                                                    <p class="text-f7 font-normal text-[#031624] min-w-[130px]"><ShimmerBadge width={100}/></p>
                                                    <div class="flex items-center">
                                                        <p class="text-f7 font-semibold text-[#031624] break-words truncate"><ShimmerBadge width={200}/></p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="pt-4">
                                                <p class="text-f7 font-normal text-[#031624]">
                                                    <ShimmerBadge width={200}/>
                                                </p>
                                                <p class="text-f7 font-normal text-[#031624]">
                                                    <ShimmerBadge width={200}/>                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                
                </div>
            </div>
        </>
    )
}
